import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { DataService } from "src/app/core/core-services/services/dataservices/data.service";
import { ScriptService } from "src/app/core/core-services/services/script.service";
import { StripeService } from "src/app/core/core-services/services/stripe.service";
import { PlansDetailsComponent } from "./plans-details.component";
import { SvgIconsModule } from "src/app/module/svg.module";
import { VngButtonComponent, VngCardComponent, VngToggleComponent } from "@vengreso/angular-components";
import { EmptyStateComponent } from "src/app/components/empty-state/empty-state.component";

@NgModule({
  declarations: [PlansDetailsComponent],
  exports: [PlansDetailsComponent],
  // C3-6: mat-card -> vng-card (R16). MatCardModule removed by C3-14 (Material
  // module pruning) — no longer used by this component's template.
  // vng-toggle (+ FormsModule for its [(ngModel)]) replaced the hand-built
  // billed-yearly/monthly CSS switch.
  // EmptyStateComponent (standalone) backs the "not eligible" panel a
  // company end user sees instead of the plan cards (issue #410).
  // VngButtonComponent + NgxSkeletonLoaderModule (issue #600): the in-page
  // plans-load error state's "Try again" button and loading placeholder.
  imports: [
    CommonModule,
    FormsModule,
    SvgIconsModule,
    VngCardComponent,
    VngToggleComponent,
    VngButtonComponent,
    NgxSkeletonLoaderModule,
    EmptyStateComponent,
  ],
  providers: [DataService, StripeService, RouterModule, ScriptService],
})
export class PlanDetailsModule {}
